'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n'], ['\n  ', '\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['padding: 0 16px 16px 16px;'], ['padding: 0 16px 16px 16px;']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  font-size: 12px;\n'], ['\n  font-size: 12px;\n']); /* eslint-disable max-len */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _View = require('../../atoms/View');

var _View2 = _interopRequireDefault(_View);

var _Link = require('../../atoms/Link');

var _Link2 = _interopRequireDefault(_Link);

var _Caption = require('../../atoms/Caption');

var _Caption2 = _interopRequireDefault(_Caption);

var _staticUrl = require('../../../config/staticUrl');

var _medias = require('../../../util/medias');

var _medias2 = _interopRequireDefault(_medias);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Content = (0, _styledComponents2.default)(_View2.default)(_templateObject, _medias2.default.small(_templateObject2));

var SmallLink = (0, _styledComponents2.default)(_Link2.default)(_templateObject3);

var LinkTerms = function LinkTerms(props) {
  return _react2.default.createElement(
    SmallLink,
    {
      target: '_blank',
      rel: 'noopener noreferrer',
      type: 'primary',
      href: props.href // eslint-disable-line
    },
    props.children
  );
};

var termsAndPrivacyNotice = function termsAndPrivacyNotice() {
  return _react2.default.createElement(
    Content,
    null,
    _react2.default.createElement(
      _Caption2.default,
      null,
      'Ao continuar, voc\xEA concorda com os ',
      _react2.default.createElement(
        LinkTerms,
        { underline: false, href: _staticUrl.termosDeUso },
        'Termos de Uso'
      ),
      '\xA0e a ',
      _react2.default.createElement(
        LinkTerms,
        { underline: false, href: _staticUrl.politicaDePrivacidade },
        'Pol\xEDtica de Privacidade'
      ),
      '\xA0da OLX, e tamb\xE9m, em receber comunica\xE7\xF5es via e-mail e push da OLX e seus parceiros.'
    )
  );
};

exports.default = termsAndPrivacyNotice;